import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

const TypedComponent = () => {
  const typedElementRef = useRef(null);

  useEffect(() => {
    const options = {
      strings: ["Gita Yuba Computer Training Center"],
      typeSpeed: 140,
      backSpeed: 80,
      backDelay: 2000,
      loop: false,
    };

    const typed = new Typed(typedElementRef.current, options);

    return () => {
      typed.destroy(); // Clean up the Typed instance when the component unmounts
    };
  }, []);

  return <span className="multiple-text" ref={typedElementRef} />;
};
export default TypedComponent;
